import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Configuration } from 'src/app/enum/Configuration';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ServiceChangeRequestService } from 'src/app/services/service-change-request.service';

@Component({
  selector: 'app-manage-service-change-popup',
  templateUrl: './manage-service-change-popup.component.html',
  styleUrls: ['./manage-service-change-popup.component.scss']
})
export class ManageServiceChangePopupComponent implements OnInit {
  displayType: any;
  head:any;
  data: any;
  ismanual: any;
  fsan: any;
  serviceproviderType = Configuration
  reasonList: any;
  vumatelNetworkIdentifier: any
  FrongfootreasonList: any;
  approveform: FormGroup;
  vapproveform: FormGroup;
  date = new Date();
  nextDate = new Date(this.date);
  complexlist: any;
  filteredList: any;
  isvumatel = false;
  isBalwin = false;
  nodata=false;
  isAgree:any;
  formattedDate:any;
  @ViewChild('effectivedate') startDatePicker: MatDatepicker<Date>;

  constructor(
    public dialogRef: MatDialogRef<ManageServiceChangePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public value: any,
    private applicationDataService: ApplicationDataService,
    private formBuilder: FormBuilder,
    private LookupDataService: LookupDataServiceService,
    private toast: NotificationService
  ) { 
    this.nextDate.setDate(this.date.getDate() + 1);
    this.formattedDate = this.formatDate(this.nextDate);
  }

  ngOnInit(): void {
    this.nextDate.setDate(this.date.getDate() + 1);

    this.displayType = this.value.title
    this.head=this.value.head;
    this.data = this.value.data;
    this.ismanual = this.value.ismanual


    this.vapproveform = this.formBuilder.group({
      effectivedate: [this.data.requestedCancellationDate],
      vumatelNetworkIdentifier: [],
      balwinComplexType: [],
      complexUnitNo: [],
      fsan: [{ value: '', disabled: true }],
      reason:[],
    })
    if(this.data.approveCancellationDate){
      this.vapproveform.controls['effectivedate'].setValue(this.data.approveCancellationDate);
    }
    this.getdata();

  }

  formatDate(date: Date | null): string {
    if (!date) return '';
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  getdata() {
    console.log(this.displayType)

    if (!this.ismanual && this.displayType!="reject") {
      this.applicationDataService.getServiceActivationNumber(this.data.applicationId).subscribe((result) => {


        if (this.data.serviceProviderId == this.serviceproviderType.Vumatel){
          this.isvumatel = true;
        this.vapproveform.controls['vumatelNetworkIdentifier'].setValue(result);
        }
        else{
        this.vapproveform.controls['fsan'].setValue(result);

          if(result==null)
            this.nodata=true;
          

        }
      })
      if (this.data.serviceProviderId == this.serviceproviderType.Balwin)
        this.isBalwin = true;
      this.LookupDataService.getBalwinComplexType().subscribe((result) => {
        this.complexlist = result;
        this.filteredList = [...this.complexlist];
        this.LookupDataService.getComplexUnitNumber(this.data.serviceChangeRequestId).subscribe((result) => {
          if(result)
          this.vapproveform.controls['ComplexUnitNo'].setValue(result);

        })
      })

    }
  }
  Close() {
    this.isAgree = "No";
    this.dialogRef.close()
  }
  onsubmit() {
    let values = this.vapproveform.getRawValue();
    console.log('before',values)

    if(this.displayType!="reject"){
      if(values.effectivedate)
        if(values.effectivedate<this.formattedDate)
          {
            this.vapproveform.controls['effectivedate'].setErrors({ required: true });
            this.toast.showError("The effectivedate date is lesser than today!")
    
              return
          }


    if (this.vapproveform.valid) {
      if (this.ismanual) {
        this.data.isAgree = "Yes";
        this.dialogRef.close();
      }
      if (this.isvumatel) {
        if (!values.vumatelNetworkIdentifier){
          this.vapproveform.controls['vumatelNetworkIdentifier'].setErrors({ required: true });
          return;
        }
      }
      if (this.isBalwin)
        if(!values.balwinComplexType &&  !values.complexUnitNo){
          this.vapproveform.controls['complexUnitNo'].setErrors({ required: true });
          this.vapproveform.controls['balwinComplexType'].setErrors({ required: true });
          return
        }
        else if (!values.balwinComplexType){
          this.vapproveform.controls['balwinComplexType'].setErrors({ required: true });
          return
        }
        else if (!values.complexUnitNo){
          this.vapproveform.controls['complexUnitNo'].setErrors({ required: true });
          return
        }





    }
  }
  else if(this.displayType=='reject'){
    console.log(values)

    if(!values.reason){
    this.vapproveform.controls['reason'].setErrors({ required: true });
    return
    }
  }

    this.isAgree = "yes";

    let data:any={isAgree:this.isAgree,data: values}
    this.dialogRef.close(data)

  }
  
}
